import axios from 'axios'
import qs from 'qs'
import config from '../config/base-config'
// import queryString from 'querystring'

const instance = axios.create({
  baseURL:config.API_PATH,
  timeout:120000,
  responseType:'json',
  headers:{
    'client':'admin',
    'Content-type':'application/x-www-form-urlencoded; charset=UTF-8',
  },
  responseEncoding: "utf8",
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  let token = sessionStorage.getItem('token')
  if (token ) {
    config.headers.token = token  //请求头加上token
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


export default {
  post_proxy(url,param){
    return instance.post(url,qs.stringify(param))
  },
  get_proxy(param){
    instance.get('test.php',{params:param}).then(response=>{

    }).catch(error=>{
      console.log(error)
    })
  },
  down_file(url,param){
    return instance.post(url,qs.stringify(param),{responseType: 'blob',timeout:30000,})
  }
}


